<script setup>
import ImageBase from '@/Components/ui/ImageBase.vue'
import IconTicks from '../../assets/svg/ico-ticks.svg'

const tickList = [
	{
		title: 'Unlimited KMs',
	},
	{
		title: 'Loss Damage Waiver',
	},
	{
		title: 'Roadside Assistance',
	},
	{
		title: 'Free Additional Drivers',
	},
]
</script>

<template>
	<ImageBase
		src="/assets/img/img-booking-hero.webp"
		alt="Rent a car from iDrive Rentals Australia"
		height="h-full"
		width="w-full"
		:to-fade-in="true"
		:is-overflow="true"
	/>

	<div class="z-10 absolute top-0 px-4 py-8 md:p-8">
		<h1 class="text-white">
			Renting a car has never been so easy. Affordable and hassle free
			rentals.
		</h1>
		<div class="mt-4 flex flex-col gap-2">
			<div
				v-for="(list, index) in tickList"
				:key="index"
				class="bg-idrive-green w-fit rounded-full px-4 py-2 flex gap-2 items-center"
			>
				<IconTicks class="stroke-gray-900" />
				<span class="font-bold">{{ list.title }}</span>
			</div>
		</div>
	</div>
</template>
